// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"927":"31d6cfe0","951":"1be7e005"}[chunkId] + ".chunk.css";
};